var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1700_4661)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.75,
    cy: 10.2803,
    r: 10,
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1599 10.2805L16.4599 5.99046C16.6482 5.80216 16.754 5.54676 16.754 5.28046C16.754 5.01416 16.6482 4.75876 16.4599 4.57046C16.2716 4.38216 16.0162 4.27637 15.7499 4.27637C15.4836 4.27637 15.2282 4.38216 15.0399 4.57046L10.7499 8.87046L6.45994 4.57046C6.27164 4.38216 6.01624 4.27637 5.74994 4.27637C5.48364 4.27637 5.22824 4.38216 5.03994 4.57046C4.85164 4.75876 4.74585 5.01416 4.74585 5.28046C4.74585 5.54676 4.85164 5.80216 5.03994 5.99046L9.33994 10.2805L5.03994 14.5705C4.94621 14.6634 4.87182 14.774 4.82105 14.8959C4.77028 15.0177 4.74414 15.1484 4.74414 15.2805C4.74414 15.4125 4.77028 15.5432 4.82105 15.665C4.87182 15.7869 4.94621 15.8975 5.03994 15.9905C5.1329 16.0842 5.2435 16.1586 5.36536 16.2094C5.48722 16.2601 5.61793 16.2863 5.74994 16.2863C5.88195 16.2863 6.01266 16.2601 6.13452 16.2094C6.25638 16.1586 6.36698 16.0842 6.45994 15.9905L10.7499 11.6905L15.0399 15.9905C15.1329 16.0842 15.2435 16.1586 15.3654 16.2094C15.4872 16.2601 15.6179 16.2863 15.7499 16.2863C15.882 16.2863 16.0127 16.2601 16.1345 16.2094C16.2564 16.1586 16.367 16.0842 16.4599 15.9905C16.5537 15.8975 16.6281 15.7869 16.6788 15.665C16.7296 15.5432 16.7557 15.4125 16.7557 15.2805C16.7557 15.1484 16.7296 15.0177 16.6788 14.8959C16.6281 14.774 16.5537 14.6634 16.4599 14.5705L12.1599 10.2805Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1700_4661"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.75 0.280273)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRed);
export default __webpack_public_path__ + "static/media/red.5e7472c3.svg";
export { ForwardRef as ReactComponent };